import { IBase64ScreenshotSet } from "../services/propertyAiGradeApiService";

export const areScreenshotsSet = (set?: IBase64ScreenshotSet): boolean => {
    return Boolean(set && set.mapbox && set.google && set.arcGis && set.bing);
}
